// extracted by mini-css-extract-plugin
export default {"container":"switchButton_container__kEpSo","buttonWrap":"switchButton_buttonWrap__coTlo","selected":"switchButton_selected__fBs4a","button":"switchButton_button__aZ11C"};